/**
 * The bridge from journal status to the save state the user sees.
 *
 * `deriveSaveState` in `@orbit-mind/shared-types` is the single place that decision is made, and
 * it needs both halves of the picture: what the local journal knows, and what the sync layer
 * knows. The journal store owns the first half and nothing else can, because it is the only
 * thing that can tell an edit that has landed on disk from one that has only been handed over.
 *
 * The second half arrives in step 31. Until then the app supplies it, and there is a trap worth
 * naming: with no server, `pendingOperations` never falls to zero, so the state is
 * `saved-locally` — which is true. What would *not* be true is `synced`, and that is exactly
 * what a map with no edits yet would derive. Hence `hasLocalWork`: before the first edit there
 * is nothing to report, and reporting anything is a claim about a server that does not exist.
 */
import { deriveSaveState } from '@orbit-mind/shared-types';
export function toSaveStateInput(status, sync) {
    return {
        filesPending: sync.filesPending === true,
        localWriteInFlight: status.localWriteInFlight,
        pendingOperations: status.pendingOperations,
        recoveryAvailable: status.recoveryAvailable,
        online: sync.online,
        syncInFlight: sync.syncInFlight,
        lastSyncFailed: sync.lastSyncFailed,
        hasConflict: sync.hasConflict,
    };
}
export function journalSaveState(status, sync) {
    return deriveSaveState(toSaveStateInput(status, sync));
}
/**
 * Has anything been journalled for this map yet?
 *
 * A save indicator shown before the first edit is a statement about work that does not exist.
 */
export function hasLocalWork(status) {
    return status.lastSequence > 0;
}
//# sourceMappingURL=save-state.js.map